import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect }    from 'react-redux';
import {
  Row,
  Col,
  Button,
  FormGroup,
  FormControl,
  ControlLabel,
  HelpBlock,
  Alert,
  Link,
  Tooltip,
  OverlayTrigger,
  Checkbox,
  Radio
}                     from 'react-bootstrap';
import { withRouter } from 'react-router';
import {
  bindActionCreators,
  compose
}                     from 'redux';

import DateTimePicker from 'react-datetime-picker';
import DateRangePicker from '@wojtekmaj/react-daterange-picker';
import moment from 'moment';

import {
  Breadcrumb as BreadcrumbComponent
}                        from '../../../components';

import { getCoutnryCity } from '../../../redux/actions/emailManagerActions';
import {renderAlert, clearAlert} from '../../../redux/actions/alertsActions';
import { unsubscribeUser } from '../../../redux/actions/frontActions';
import { CSVLink } from "react-csv";

let cityID = [];
let csvData = [];
let isLoading = "false";
class Unsubscription extends Component {
  constructor(props){
    super(props);
    this.state = {
      cityList: '',
      cityID: '',
      cityError: false,
      dateError: false,
      allCheck: false,
      zipcode: '',
      firstName: '',
      lastName: '',
      email: '',
      allCity: 'no',
      frequency: 'DAILY',
      show: false,
      alertMessage: '',
      hover: false,
    }
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleDismiss = this.handleDismiss.bind(this);
  }

  hoverOn = (e) => {
    this.setState({ hover: true, hoverID: e.target.attributes.getNamedItem("data-id").value });
  }

  hoverOff = (e) => { 
    this.setState({ hover: false, hoverID: e.target.attributes.getNamedItem("data-id").value });    
  }

  componentWillMount(){
    if(this.props.themeData){
      if(this.props.themeData.button){
        this.setState({
          button_color: this.props.themeData.button.button_color,
          mouseover_color: this.props.themeData.button.mouseover_color,
        });
      }
    }
    isLoading = "true";
    this.props.clearAlert();
    this.props.getCoutnryCity();
  }

  handleShow() {
    this.setState({ show: true });
  }

  handleDismiss() {
    this.setState({ show: false });
  }

  componentWillReceiveProps(nextProps){
    if(nextProps.themeData){
      if(nextProps.themeData.button){
        this.setState({
          button_color: nextProps.themeData.button.button_color,
          mouseover_color: nextProps.themeData.button.mouseover_color,
        });
      }
    }
    if(this.props.cityList !== nextProps.cityList){
        if(nextProps.cityList){
          isLoading = "false";
          this.setState({cityList: nextProps.cityList.data});
        }
    } 

    if(this.props.subscribeStatus != nextProps.subscribeStatus){
      if(nextProps.subscribeStatus){
        isLoading = "false";
        this.handleShow();
        this.props.renderAlert('success',nextProps.subscribeStatus.message);
      }
    }

    if(this.props.error !== nextProps.error){
      if(nextProps.error){
        this.props.clearAlert ();
        this.handleShow();
        this.props.renderAlert('warning',nextProps.error);
        isLoading="false";
      }
  }

  if(nextProps.message){
        this.handleShow();
        this.setState({alertMessage:nextProps.message, msgType:nextProps.alertType});
        window.scrollTo(0, 0);
    }

  }

  handleChange = (e) => {
    if(e.target.name == 'email'){
      this.setState({emailError: false});
    }
    this.setState({[e.target.name]: e.target.value})
  }

  handleCityData = (e) => {
    cityID = (this.state.cityID) ? this.state.cityID : [];
    let index;

    if (e.target.checked) {
      cityID.push(e.target.value);
    } else {
      index = cityID.indexOf(e.target.value)
      cityID.splice(index, 1)
    }
    this.setState({cityError: false});
    this.setState({cityID : cityID});
  }

  handleAllCheck = (e) => {
    if (e.target.checked) {
      this.setState({allCheck : true, allCity: 'yes',  cityError: false  });
    } else {
      this.setState({allCheck : false, allCity: 'no' });
    }
  }


  validate = (e) => {
    let isError = false;
    if(this.state.cityID.length == 0 && this.state.allCity == 'no'){
      isError = true;
      this.setState({cityError: true});
    }else{
      this.setState({cityError: false});
    }

    if(!this.state.email){
      isError = true;
      this.setState({emailError: 'red'});
    }

    return isError;
  }

  handleSubmit = (e) => {
    e.preventDefault();
    let isError = this.validate();
    // let referredBy = cookies.get("referredBy");
    if(!isError){
      const constData = {
        firstName: this.state.firstName,
        lastName: this.state.lastName,
        email: this.state.email,
        allCity: this.state.allCity,
        city: (this.state.cityID) ? this.state.cityID : [],
        zipcode: this.state.zipcode,
        frequency: this.state.frequency,
        unsubscribe: 'no',
        // affiliateID: referredBy,
      }
      isLoading = "true";
      this.props.unsubscribeUser(constData);
    }
  }

  validateEmail = (e) =>{
    let isError = false;

    if(!this.state.email){
      isError = true;
      this.setState({emailError: 'red'});
    }

    return isError;
  }

  handleSubscribe = (e) => {
    e.preventDefault();
    let isError = this.validateEmail();
    // let referredBy = cookies.get("referredBy");
    if(!isError){
      const constData = {
        email: this.state.email,
        unsubscribe: 'yes',
        frequency: this.state.frequency,
        allCity: this.state.allCity,
        city: (this.state.cityID) ? this.state.cityID : [],
      }
      isLoading = "true";
      this.props.unsubscribeUser(constData);
    }
  }

  handSubscriptionDate = (e) => {
     if (e.target.checked) {
      this.setState({startDateRangeStatus : false, startDateValue: 'all', startDateRange: ''})
     } else {
      this.setState({startDateRangeStatus : true, startDateValue: ''})
     }

     this.setState({dateError: false});
  }

  render() {
    
  return (
    <div className="container">
      <div className="col-lg-12 add-sub-admin">
        {isLoading == "true" ? (
          <div className="loader">
            <p className="loading-message">
              <i>Loading...</i>
            </p>
            <div className="spinner">
              <div className="dot1" />
              <div className="dot2" />
            </div>
          </div>
        ) : (
          ""
        )}
        <form>
          <div className="panel">
              <header className="panel-heading">Manage Subscriptions</header>
              {this.state.show && this.state.alertMessage !=='' &&        
                <div className="col-lg-12">
                  <Alert bsStyle={this.state.msgType} onDismiss={this.handleDismiss}>
                  <strong>{this.state.msgType}:</strong> {this.state.alertMessage}
                </Alert>
                </div>
              }
              <div className="panel-body">
              <Row>
                  <Col md={12} xs={12}>
                    <FormGroup>
                      <Row>
                          <Col md={4} xs={4}>
                            <ControlLabel>Email:</ControlLabel>
                            <FormControl
                              type="text"
                              placeholder="Email Address"
                              defaultValue={this.state.email}
                              name="email"
                              onChange={this.handleChange}
                              style={{borderColor:this.state.emailError}}
                            />
                          </Col>
                      </Row>
                      
                      <Row>
                          <Col md={12} xs={12}>
                            <ControlLabel>Cities: <span className="text-danger">{(this.state.cityError) ? '(Please select city.)' : ''}</span></ControlLabel>
                          </Col>
                          <Col md={12} xs={12}>
                            <Checkbox value="all" onClick={this.handleAllCheck}>Select All City</Checkbox>
                          </Col>
                      </Row>
                      {(this.state.cityList) &&
                        this.state.cityList.map((data, index) =>
                          <Row>
                          <Col md={12} xs={12}><b>{(data.cities.length != 0) ? data.country : ''}</b></Col>
                            <Col md={12} xs={12}>
                              <Row>
                              {data.cities.map((cityData, index) => 

                                  <Col md={4} xs={12}>
                                    {(cityID.indexOf(JSON.stringify(cityData.cityID)) > -1) ?
                                    // <div>check</div>
                                    <Checkbox onClick={this.handleCityData} defaultChecked={true} value={cityData.cityID}>{cityData.title}</Checkbox>
                                    :
                                    <Checkbox onClick={this.handleCityData} checked={this.state.allCheck}  value={cityData.cityID}>{cityData.title}</Checkbox>
                                    }
                                  </Col>
                                )
                              }
                              </Row>
                            </Col>
                          </Row>
                        )
                      }
                    </FormGroup>
                  </Col>
                  
              </Row>
              <Row>
                <Col md={12} xs={12}>
                <ControlLabel>Choose your preferred email frequency: </ControlLabel>
                </Col>
                <Col md={12} xs={12}>
                  {(this.state.frequency == 'DAILY') ?
                  <Radio name="frequency" checked={true} value="DAILY">Daily</Radio>
                  :
                  <Radio name="frequency" value="DAILY">Daily</Radio>
                  }
                </Col>
                <Col md={12} xs={12}>
                  {(this.state.frequency == 'WEEKLY') ?
                  <Radio name="frequency" checked={ true} value="WEEKLY">Weekly</Radio>
                  :
                  <Radio name="frequency" value="WEEKLY">Weekly</Radio>
                  }
                </Col>
                <Col md={12} xs={12}>
                  {(this.state.frequency == 'TWICEINMONTH') ?
                  <Radio name="frequency" checked={ true} value="TWICEINMONTH">Twice In Month</Radio>
                  :
                  <Radio name="frequency" value="TWICEINMONTH">Twice In Month</Radio>
                  }
                </Col>
              </Row>
              
              <Row><hr/></Row>
              <Row>
                <Col md={12} xs={12}>
                  <Button 
                  type="submit" 
                  bsStyle="success" 
                  onClick={this.handleSubmit} 
                  style={{backgroundColor: (this.state.hover && this.state.hoverID == 'Subscribe') ? this.state.mouseover_color : (this.state.button_color) ? this.state.button_color : '#77C84E' }}
                  data-id = {'Subscribe'}
                  onMouseEnter={this.hoverOn} 
                  onMouseLeave={this.hoverOff}
                  >Subscribe</Button>
                  <Button 
                  type="submit" 
                  bsStyle="danger" 
                  onClick={this.handleSubscribe} 
                  style={{backgroundColor: (this.state.hover && this.state.hoverID == "unsubscriber") ? this.state.mouseover_color : this.state.button_color}}
                  data-id = {"unsubscriber"}
                  onMouseEnter={this.hoverOn} 
                  onMouseLeave={this.hoverOff}
                  >Unsubscribe</Button>
                  <a className="btn btn-default" href="/">Cancel</a>
                </Col>
              </Row>
              </div>
          </div>
        </form>
      </div>
    </div>
  )
  }
}

const mapStateToProps = (state,ownProps) => {
    return {
      subscribeStatus: state.frontReducer.subscribeStatus,
      error: state.frontReducer.error,
      cityList:  state.emailManagerReducer.cityList,
      alertType: state.alertsReducer.alertType,
      message: state.alertsReducer.message,
    };
};
export default compose(
  withRouter, 
  connect(mapStateToProps, {getCoutnryCity, unsubscribeUser, renderAlert, clearAlert})
)(Unsubscription);


// WEBPACK FOOTER //
// ./src/app/views/frontend/subscription/Unsubscription.js